import { gql } from '@apollo/client';

export const CLAIM_ENDPOINT = gql`
  mutation Mutation($where: EndpointWhereUniqueInput!) {
    claimEndpoint(where: $where) {
      id
    }
  }
`;
